
import { DateComponent } from '../../domain/Event'

export class EventDTO {

    constructor(
        public id: string,
        public displayName: string,
        public displayOrder: number,
        public description: string,
        public imageId: string | null,
        public cancellationChargeAmount: number | null,
        public cancellationChargePartyAmount: number | null,
        public cancellationChargeCutOffHours: number | null,
        public depositAmount: number | null,
        public depositFlatFeeAmount: number | null,
        public depositRefundCutOffDays: number | null,
        public isExclusive: boolean,
        public questionIds: string[],
        public notReservableOnline: boolean,
        public notReservableOnlineMessage: string | null,
        public recurrence: EventRecurrenceDTO,
        public partySizeRestriction: number[] | null,
        public partySizeRestrictedMessage: string | null,
        public dogFriendlyNotAllowed: boolean,
        public minLargePartySize: number | null,
        public tableIds: string[]
    ) { }
}

export class EventRecurrenceDTO {

    constructor(
        public startDates: string[],
        public dateComponent: DateComponent | null,
        public weeklyRepeatsOnDaysOfWeek: number[] | null,
        public monthlyRepetitionType: MonthlyRepetitionTypeDTO | null,
        public exceptions: EventExceptionDTO[],
        public endDate: string | null,
        public startTime: string | null,
        public endTime: string | null
    ) { }
}

export enum MonthlyRepetitionTypeDTO {
    DAY_OF_MONTH = 'DAY_OF_MONTH',
    DAY_OF_WEEK = 'DAY_OF_WEEK',
}

export class EventExceptionDTO {

    constructor(
        public id: string,
        public date: string
    ) { }
}
